"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSMOSYS_IN_DEV_MODE = process.env.NODE_ENV === 'development';
exports.OSMOSYS_DEBUG_ANALYTICS = false && exports.OSMOSYS_IN_DEV_MODE;
//# sourceMappingURL=debug.js.map